import { backArrowIcon, logoIcon } from 'assets/icons';
import { useCommunity } from "./CommunityContext";
import { useAppDispatch } from "app/hooks";
import { authActions } from "redux/reducers/auth";
interface Props {
  withBackArrow: boolean;
  onBack?: () => void;
  className?: string;
  hasLogo?: boolean;
  title?: string;
  isBlackLogo?: boolean;
}

const Header: React.FC<Props> = ({
  withBackArrow,
  onBack,
  className,
  hasLogo = true,
  title,
  isBlackLogo = false,
}) => {
  const headerClassName = className ?? '';
  const { assets } = useCommunity();
  const dispatch = useAppDispatch();

  const logoutBlacklist = ['/onboarding', '/login'];
  const isLogoutAllowed = !logoutBlacklist.includes(window.location.pathname);
  const onLogout = () => {
    if (isLogoutAllowed) {
      dispatch(authActions.logout());
    }
  };

  return (
    <div className={`header ${withBackArrow ? 'header-back-btn' : ''} ${headerClassName}`}>
      {withBackArrow && (
        <span onClick={onBack} className="step-arrow-back">
          <img src={backArrowIcon} alt="Back" />
        </span>
      )}
      {hasLogo && <img src={assets?.logo?.icon} alt="Logo" style={{ height: assets?.logo?.height }}></img>}
      {title && <span className="title-bold">{title}</span>}
      {withBackArrow && <div></div>}
      {isLogoutAllowed && <div className="logout-button" onClick={onLogout}>Log Out</div>}
    </div>
  );
};

export default Header;
